module.exports = __webpack_public_path__ + "static/img/chuang-1.861a486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/chuang-1.jpg
// module id = 0EJc
// module chunks = 0